import { render, staticRenderFns } from "./chips.vue?vue&type=template&id=c16d3442&"
import script from "./chips.vue?vue&type=script&lang=js&"
export * from "./chips.vue?vue&type=script&lang=js&"
import style0 from "./chips.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/projects/zp-front-up/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c16d3442')) {
      api.createRecord('c16d3442', component.options)
    } else {
      api.reload('c16d3442', component.options)
    }
    module.hot.accept("./chips.vue?vue&type=template&id=c16d3442&", function () {
      api.rerender('c16d3442', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chips/chips.vue"
export default component.exports